import React, { useEffect, useState } from 'react';
import { Modal } from "react-morphing-modal";
import "react-morphing-modal/dist/ReactMorphingModal.css";
import './styleDashboard.css';
import { Col, Row} from 'reactstrap';

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

export const ModalTrazabilidadSampleDashboard = (
    { treeviewRef, close, namePatient, dataSection, dataID
        , idGender, dataInformation, dataSample, dataSendProcess2, dataSendProcess3, dataTrackingRecepetion, itemsTree, refusedGlobal, loadingTrazability,
        filterSections,handleFilterSections,dataTraceability,exportToExcelTrazability, ...props }) => {

    const [globalFilter, setGlobalFilter] = useState("");
    const [expandedRows, setExpandedRows] = useState([]); 
    const containerStyle = { width: '100%', overflowX: 'auto' };

    useEffect(() => {
    const initialExpandedRows = dataTraceability.filter(
        item => (item.type === 'profile' && item.children?.length > 0) || item.is_curve
    );
    setExpandedRows(initialExpandedRows);
}, [dataTraceability]);



const rowExpansionTemplate = (rowData) => {
    if (rowData.type === "profile") {
        return (
            <div style={containerStyle}>
                <DataTable
                value={rowData.listExm}
                className="data-table"
                emptyMessage={
                    <div className="text-center">
                        <img
                            src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                            style={{ width: "60%" }}
                            alt="Sin resultados"
                        />
                        <br />
                        <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>
                            No hay detalles de perfil disponibles
                        </p>
                    </div>
                }
                style={{ fontSize: "12px", width: '100%' }}
                scrollable
                scrollWidth="100%"
            >
                <Column field="name" header="Estudio"  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "4px",
                }}
                style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "12%",
                }}/>               
                <Column field="is_toma" header="Toma de muestra" body={(rowData) => (rowData.type === 'profile' ? "" : (rowData.is_toma ? <i className='fa fa-check txt-success f-18' ></i>  :  rowData.check_forwarded ? "Remitida": <i className='fa fa-times text-danger f-16' ></i>))}  headerStyle={{
                    backgroundColor: "#94bcd5",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "4px",
                }}
                style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "12%",
                }} />
                <Column field="init_time" header="Fecha Inicio" body={row => row.traceabilitSampling && row.traceabilitSampling.length > 0 ? row.traceabilitSampling[0].init_time :  row.check_forwarded ? "N/A" : "Sin Fecha" }  headerStyle={{
                    backgroundColor: "#94bcd5",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "4px",
                }}
                style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "12%",
                }}/>
                <Column field="flebo" header="Usuario" body={row => row.traceabilitSampling && row.traceabilitSampling.length > 0 ? row.traceabilitSampling[0].flebo : row.check_forwarded ? "N/A" : "Sin Usuario" }  headerStyle={{
                    backgroundColor: "#94bcd5",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "4px",
                }}
                style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "12%",
                }} />
                <Column field="is_send1" header="Envío" body={(rowData) => (rowData.type === 'profile' ? "" : (rowData.is_send1 ? <i className='fa fa-check txt-success f-18' ></i>  : <i className='fa fa-times text-danger f-16' ></i>))}  headerStyle={{
                    backgroundColor: "#0079c7",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "4px",
                }}
                style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "12%",
                }}/>
                <Column field="init_time_procces2"
                header="Fecha Envio"
                body={row => row.traceabilitSend && row.traceabilitSend.length > 0
                    ? row.traceabilitSend[row.traceabilitSend.length - 1].init_time_procces2
                    : "Sin Fecha"}
                headerStyle={{
                    backgroundColor: "#0079c7",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "4px",
                }}
                style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "12%",
                }}
                 />
                <Column field="user_process2" 
                header="Usuario de Envio" 
                body={row => row.traceabilitSend && row.traceabilitSend.length > 0
                    ? row.traceabilitSend[row.traceabilitSend.length - 1].user_process2
                    : "Sin Usuario"}
                headerStyle={{
                    backgroundColor: "#0079c7",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "4px",
                }}
                style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "12%",
                }}
                />
                <Column field="is_send2" header="Recepción" body={(rowData) => (rowData.type === 'profile' ? "" : (rowData.is_send2 ? <i className='fa fa-check txt-success f-18' ></i>  : <i className='fa fa-times text-danger f-16' ></i>))}  headerStyle={{
                    backgroundColor: "#46afe5d4",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "4px",
                }}
                style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "12%",
                }}/>
                <Column 
                    field="init_time_procces3" 
                    header="Fecha Recepción" 
                    body={row => row.traceabilitSend && row.traceabilitSend.length > 0
                        ? row.traceabilitSend[row.traceabilitSend.length - 1].init_time_procces3
                        : "Sin Fecha"}
                    headerStyle={{
                    backgroundColor: "#46afe5d4",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "4px",
                }}
                style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "12%",
                }}
                />
                <Column field="user_process3" 
                header="Usuario Recepción"
                 body={row => row.traceabilitSend && row.traceabilitSend.length > 0
                    ? row.traceabilitSend[row.traceabilitSend.length - 1].user_process3
                    : "Sin Usuario"}
                headerStyle={{
                    backgroundColor: "#46afe5d4",
                    color: "#fff",
                    fontWeight: "bold",
                     fontSize: "10px",
                    padding: "4px",
                }}
                style={{
                     fontSize: "10px",
                    textAlign: "center",
                    width: "12%",
                 }}
                  />
             </DataTable>
            </div>
        );
    }

    if (rowData.is_curve && rowData.arrayCurves?.length > 0) {
        return (
            <div style={{ padding: "0rem" }}>
                {/* <strong>{rowData.name} </strong> */}
                <table style={{ width: "100%", fontSize: "10px", borderCollapse: "collapse", marginTop: "4px" }}>
                    <thead>
                        <tr style={{  textAlign: "center" }}>
                            <th style={{ border: "1px solid #ccc", padding: "2px",backgroundColor:"#1d5b83",color:"#fff" }}>N° Toma</th>                    
                            <th style={{ border: "1px solid #ccc", padding: "2px",backgroundColor:"#94bcd5",color:"#fff"  }}>Toma de muestra</th>
                            <th style={{ border: "1px solid #ccc", padding: "2px",backgroundColor:"#94bcd5",color:"#fff"  }}>Fecha Toma</th>
                            <th style={{ border: "1px solid #ccc", padding: "2px",backgroundColor:"#94bcd5",color:"#fff"  }}>usuario</th>
                            <th style={{ border: "1px solid #ccc", padding: "2px",backgroundColor:"#0079c7",color:"#fff"  }}>Envío</th>
                            <th style={{ border: "1px solid #ccc", padding: "2px", backgroundColor:"#0079c7",color:"#fff" }}>Fecha Envío</th>
                            <th style={{ border: "1px solid #ccc", padding: "2px",backgroundColor:"#0079c7",color:"#fff"  }}>Usuario Envío</th>
                            <th style={{ border: "1px solid #ccc", padding: "2px",backgroundColor:"#46afe5d4" ,color:"#fff"}}>Recepción</th>
                            <th style={{ border: "1px solid #ccc", padding: "2px",backgroundColor:"#46afe5d4",color:"#fff" }}>Fecha Recepción</th>
                            <th style={{ border: "1px solid #ccc", padding: "2px",backgroundColor:"#46afe5d4",color:"#fff" }}>Usuario Recepción</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rowData.arrayCurves.map((item, idx) => (
                            <tr key={idx} style={{ textAlign: "center" }}>
                                <td style={{ border: "1px solid #ccc", padding: "2px" }}>{item?.num_samplings ?? 0}</td>
                                <td style={{ border: "1px solid #ccc", padding: "2px" }}>{item?.user_flebo ===  null ?  <i className='fa fa-times text-danger f-16' ></i> :   <i className='fa fa-check txt-success f-18' ></i>  ?? "N/A"}</td>
                                <td style={{ border: "1px solid #ccc", padding: "2px" }}>{item?.init_time_flebo ?? "---"}</td>
                                <td style={{ border: "1px solid #ccc", padding: "2px" }}> {item?.user_flebo ?? "---"}  </td>
                                <td style={{ border: "1px solid #ccc", padding: "2px" }}>{item?.user_process2 ===  null ?  <i className='fa fa-times text-danger f-16' ></i> :   <i className='fa fa-check txt-success f-18' ></i>  ?? "N/A"}</td>
                                <td style={{ border: "1px solid #ccc", padding: "2px" }}>{item?.init_time_procces2 ?? "---"}</td>
                                <td style={{ border: "1px solid #ccc", padding: "2px" }}>{item?.user_process2 ?? "---"}</td>
                                <td style={{ border: "1px solid #ccc", padding: "2px" }}>{item?.user_process3 ===  null ?  <i className='fa fa-times text-danger f-16' ></i> :   <i className='fa fa-check txt-success f-18' ></i> ?? "N/A"}</td>
                                <td style={{ border: "1px solid #ccc", padding: "2px" }}>{item?.init_time_procces3 ?? "---"}</td>
                                <td style={{ border: "1px solid #ccc", padding: "2px" }}>{item?.user_process3 ?? "---"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }
    return null;
};

    
    return (
    <Modal {...props} padding={false} closeButton={false}>
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <div
                style={{
                    display: "flex",
                    padding: "10px 10px",
                }}
            >
                <Col sm="12">
                    <Row>
                        <Col sm="4"  >
                        <ul className="list-group" style={{display:'-webkit-box', width:'100%'}}>
                            <li style={{fontSize:"12px", maxWidth: "150px"}} className="list-group-item list-group-item-success rounded-lg text-center font-weight-bold px-4">Con muestra</li>
                            <li style={{fontSize:"12px", maxWidth: "150px"}} className="list-group-item list-group-item-primary rounded-lg text-center font-weight-bold px-4">Remitida</li>
                            <li style={{fontSize:"12px", maxWidth: "150px", backgroundColor: '#ff8f00a6'}} className="list-group-item list-group-item rounded-lg text-center font-weight-bold px-4">Sin muestra</li>
                        </ul>
                        </Col>
                    </Row>
                </Col>
                <button className="butto-full-modal" onClick={close}>
                    <label className="f-20">X</label>
                </button>
            </div>
            <Col sm="12" className="pt-4">
                {loadingTrazability ? (
                    <>
                    <Row className='mt-2'>
                        <Col xs="12" sm="12" md="12" lg="12" xl="12" className='text-center'>  <br />
                            <img src={require("../../../assets/images/loginHelenLabs/HelenLabs.png")} className='animate__animated animate__pulse animate__infinite ' style={{ width: '130px' }} />
                        </Col>
                    </Row>
                    <Row className='mt-2'>
                        <Col sm="2" md="2" lg="2" className='text-center'></Col>
                        <Col sm="3" md="3" lg="3" className='text-left p-r-0'>
                            <p className='f-18 text-primary animate__animated animate__pulse animate__infinite'> <b>Cargando</b></p>
                        </Col>
                        <Col sm="1" md="1" lg="1" className='text-center'>
                            <br />
                            <p className='animate__animated animate__fadeInDown animate__infinite text-info'><i className="fa fa-circle f-14"></i></p>
                        </Col>
                        <Col sm="1" md="1" lg="1" className='text-center'>
                            <br />
                            <p className='animate__animated animate__fadeInDown animate__slow animate__infinite text-primary'><i className="fa fa-circle f-14"></i></p>
                        </Col>
                        <Col sm="1" md="1" lg="1" className='text-center'>
                            <br />
                            <p className='animate__animated animate__fadeInDown animate__slower animate__infinite text-info'><i className="fa fa-circle f-14"></i></p>
                        </Col>
                        <Col sm="2" md="2" lg="2" className='text-center'></Col>
                    </Row>
                    </>
                ) : (

                    <Col sm="12" className='p-l-0 p-r-0 ' >
                    <DataTable
                        value={dataTraceability}
                        className="data-table data-table-centered"
                        emptyMessage={
                            <div className="text-center">
                                <img
                                    src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                    style={{ width: "135%" }}
                                    alt="Sin resultados"
                                />
                                <br />
                                <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                    Sin Información de trazabilidad.
                                </p>
                            </div>
                        }
                        style={{ fontSize: "8px" }}
                        scrollable
                        globalFilter={globalFilter}
                        expandedRows={expandedRows}
                        onRowToggle={(e) => setExpandedRows(e.data)}
                        rowExpansionTemplate={rowExpansionTemplate}
                        header={
                            <div className="p-d-flex p-jc-between">
                                <button
                                    className="p-button p-button-success"
                                    onClick={() => exportToExcelTrazability(dataTraceability)}
                                    title="Reporte completo de empresas"
                                    style={{
                                        alignItems: "center",
                                        padding: "5px 8px",
                                        height: "35px",
                                        width: "35px",
                                        fontSize: "0.9rem",
                                    }}
                                >
                                <i className="pi pi-file-excel" style={{ fontSize: "1rem", marginRight: "5px" }}></i>
                                </button>
                            </div>
                    }
                    >
                      <Column
                        expander={(rowData) => {
                            return rowData.type === 'exam' ? "" : true;
                        }}
                        headerStyle={{
                            backgroundColor: "#1d5b83",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "5px", 
                            padding: "2px",    
                        }}
                        style={{
                            fontSize: "5px",  
                            textAlign: "center",
                            width: "3%",      
                            maxWidth: "50px", 
                            whiteSpace: "nowrap",  
                            overflow: "hidden",   
                        }}
                    />
                        <Column
                            field="name"
                            header="Estudio"
                            body={(rowData) => {
                                return   rowData.type === 'exam' ? rowData.name : rowData.profile_name;
                            }}
                            headerStyle={{
                                backgroundColor: "#1d5b83",
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "10px",
                                padding: "4px",
                            }}
                            style={{
                                fontSize: "10px",
                                textAlign: "center",
                                width: "12%",
                            }}
                        />
                        <Column
                            field="is_toma"
                            header="Toma de muestra"
                            body={(rowData) => (rowData.is_curve ? "" : rowData.type === 'profile' ? "" : (rowData.is_toma ? <i className='fa fa-check txt-success f-18' ></i>  : rowData.check_forwarded ? "Remitida": <i className='fa fa-times text-danger f-16' ></i>))}
                            headerStyle={{
                                backgroundColor: "#94bcd5",
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "10px",
                                padding: "4px",
                            }}
                            style={{
                                fontSize: "10px",
                                textAlign: "center",
                                width: "12%",
                            }}
                        />
                        <Column
                            field="init_time"
                            header="Fecha Toma"
                            body={(rowData) => (rowData.is_curve ? "" : rowData.type === 'profile' ? "" : (rowData.traceabilitSampling && rowData.traceabilitSampling.length > 0 ? rowData.traceabilitSampling[0].init_time : rowData.check_forwarded ? "N/A": "Sin Fecha"))}
                            headerStyle={{
                                backgroundColor: "#94bcd5",
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "10px",
                                padding: "4px",
                            }}
                            style={{
                                fontSize: "10px",
                                textAlign: "center",
                                width: "12%",
                            }}
                        />
                        <Column
                            field="flebo"
                            header="Usuario"
                            body={(rowData) => (rowData.is_curve ? "" : rowData.type === 'profile' ? "" : (rowData.traceabilitSampling && rowData.traceabilitSampling.length > 0 ? rowData.traceabilitSampling[0].flebo : rowData.check_forwarded ? "N/A" : "Sin Usuario"))}
                            headerStyle={{
                                backgroundColor: "#94bcd5",
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "10px",
                                padding: "4px",
                            }}
                            style={{
                                fontSize: "10px",
                                textAlign: "center",
                                width: "12%",
                        }}
                        />
                        <Column
                            field="is_send1"
                            header="Envio"
                            body={(rowData) => ( rowData.is_curve ? "" : rowData.type === 'profile' ? "" : (rowData.is_send1 ? <i className='fa fa-check txt-success f-18' ></i>  :  rowData.traceabilitSend.some(send => send.user_process2 ) ? (
                            <i className='fa fa-check txt-success f-18'></i>
                            ) : (
                            <i className='fa fa-times text-danger f-16'></i>
                            )))}                            headerStyle={{
                                backgroundColor: "#0079c7",
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "10px",
                                padding: "4px",
                            }}
                            style={{
                                fontSize: "10px",
                                textAlign: "center",
                                width: "12%",
                            }}
                        />
                        <Column
                            field="init_time_procces2"
                            header="Fecha de Envio"
                            body={row => row.traceabilitSend && row.traceabilitSend.length > 0
                                ? row.traceabilitSend[row.traceabilitSend.length - 1].init_time_procces2
                                : ""}
                            headerStyle={{
                                backgroundColor: "#0079c7",
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "10px",
                                padding: "4px",
                            }}
                            style={{
                                fontSize: "10px",
                                textAlign: "center",
                                width: "12%",
                            }}
                        />
                        <Column
                            field="user_process2"
                            header="Usuario de Envio"
                            body={row => row.traceabilitSend && row.traceabilitSend.length > 0
                                ? row.traceabilitSend[row.traceabilitSend.length - 1].user_process2
                                : ""}
                            headerStyle={{
                                backgroundColor: "#0079c7",
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "10px",
                                padding: "4px",
                            }}
                            style={{
                                fontSize: "10px",
                                textAlign: "center",
                                width: "12%", 
                            }}
                        />
                        <Column
                            field="is_send2"
                            header="Recepción"
                            body={(rowData) => ( rowData.is_curve ? "" : rowData.type === 'profile' ? "" : (rowData.is_send2 ? <i className='fa fa-check txt-success f-18' ></i>  :  rowData.traceabilitSend.some(send => send.user_process3) ? (
                                <i className='fa fa-check txt-success f-18'></i>
                                ) : (
                                <i className='fa fa-times text-danger f-16'></i>
                                )))}                            headerStyle={{
                                backgroundColor: "#46afe5d4",
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "10px",
                                padding: "4px",
                            }}
                            style={{
                                fontSize: "10px",
                                textAlign: "center",
                                width: "12%",
                            }}
                        />
                        <Column
                            field="init_time_procces3"
                            header="Fecha Recepción"
                            body={row => row.traceabilitSend && row.traceabilitSend.length > 0
                                ? row.traceabilitSend[row.traceabilitSend.length - 1].init_time_procces3
                                : ""}
                            headerStyle={{
                                backgroundColor: "#46afe5d4",
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "10px",
                                padding: "4px",
                            }}
                            style={{
                                fontSize: "10px",
                                textAlign: "center",
                                width: "12%",
                            }}
                        />
                        <Column
                            field="user_process3"
                            header="Usuario de Recepción"
                            body={row => row.traceabilitSend && row.traceabilitSend.length > 0
                                ? row.traceabilitSend[row.traceabilitSend.length - 1].user_process3
                                : ""}
                            headerStyle={{
                                backgroundColor: "#46afe5d4",
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "10px",
                                padding: "4px",
                            }}
                            style={{
                                fontSize: "10px",
                                textAlign: "center",
                                width: "12%",
                            }}
                        />      
                      
                    </DataTable>
                    <br /><br />
                </Col>

                )}

            </Col>
        </div>
    </Modal>
    )
}




